/**
 * cast to DateTimeFormat
 * @param format Object
 * @returns DateTimeFormat
 */
export const castDateTimeFormat = (format) => format

/**
 * cast to NumberFormat
 * @param format Object
 * @returns NumberFormat
 */
export const castNumberFormat = (format) => format
